import gql from 'graphql-tag'

export default gql`
  fragment PostAiAssistantLogs on Post {
    aiAssistantResponseLogs {
      aiResponse
      promptType
      updatedAt
      userPrompt
    }
  }
`
